import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import {
  flexStart,
  spaceTopRelaxed,
  SPACE_COMPACT,
  colors,
  borderColor,
  SPACE_MINIMUM,
  SPACE_COZY,
} from '@/styles';

export const listRowLayout = [
  flexStart,
  spaceTopRelaxed,
  css`
    align-items: baseline;
    padding-bottom: ${SPACE_COMPACT}px;
    h3,
    h5 {
      margin-right: ${SPACE_COZY}px;
    }
  `,
];

export const listInfoGapStyles = css`
  margin-right: ${SPACE_COZY}px;
`;

export const tableBottomBorderStyles = css`
  &:last-child {
    border-bottom: 2px solid ${borderColor};
  }
`;

export const tableBorderStyles = css`
  ${tableBottomBorderStyles}

  &:nth-of-type(1) {
    border-top: 2px solid ${borderColor};
  }
`;

export const tableRowOuterStyles = [
  css`
    &:hover {
      background-color: ${token('color.background.neutral.subtle.hovered', colors.N10A)};
    }
  `,
];

export const tableRowSelectedStyles = css`
  background-color: ${token('color.background.neutral.subtle.hovered', colors.N10A)};
`;

export const tableRowInnerStyles = css`
  display: flex;
  justify-content: space-between;
  padding: ${SPACE_MINIMUM}px 0px;
`;

export const tableStyles = css`
  display: grid;
  margin-top: ${SPACE_COZY}px;
`;
